import controller from './deployment-frequency.controller';
import template from './deployment-frequency.html';

export default { controller, template };



// WEBPACK FOOTER //
// ./src/app/authorized/newDashBoard/components/widgets/deployment-frequency/deployment-frequency.component.js